import { provideWidgetClass } from "scrivito"
import { Alignment } from "shared/lib/layout/Alignment"
import { ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export const allowedButtonWidgetIcons = [
  IconName.PROJECTS,
  IconName.APPS,
  IconName.BUILDING,
  IconName.COMMENT,
  IconName.DIMENSIONING,
  IconName.USER
]

export const LoginButtonWidget = provideWidgetClass("LoginButtonWidget", {
  attributes: {
    alignment: ["enum", { values: Object.values(Alignment) }],
    variant: [
      "enum",
      {
        values: [
          ButtonVariant.PRIMARY,
          ButtonVariant.SECONDARY,
          ButtonVariant.TERTIARY
        ]
      }
    ],
    icon: [
      "enum",
      {
        values: Object.values(IconName).filter(icon =>
          allowedButtonWidgetIcons.includes(icon)
        )
      }
    ],
    text: "string"
  }
})
